import { v3ApiHttp } from '@/services/api/tattle-http'
import type {
  GetAdministratorsForImpersonationResponse,
  ImpersonateAdminResponse
} from './admin-impersonation.types'

/**
 * API service for administrator-to-administrator impersonation
 */
export const adminImpersonationAPI = {
  /**
   * Get all administrators available for impersonation
   */
  async getAdministrators(): Promise<GetAdministratorsForImpersonationResponse> {
    const response = await v3ApiHttp.get<GetAdministratorsForImpersonationResponse>(
      '/admin/administrators/impersonation'
    )
    return response.data
  },

  /**
   * Impersonate an administrator and get an access token
   */
  async impersonateAdmin(
    administratorId: number,
    durationMinutes: number
  ): Promise<ImpersonateAdminResponse> {
    const response = await v3ApiHttp.post<ImpersonateAdminResponse>(
      `/admin/administrators/impersonation/${administratorId}/impersonate`,
      { durationMinutes }
    )
    return response.data
  },

  /**
   * End the current impersonation session
   */
  async endImpersonation(): Promise<void> {
    await v3ApiHttp.post('/admin/administrators/impersonation/end')
  }
}
